import React from "react"
import Seo from "../components/seo"
import StandardLayout from "../components/highlighted-work/standard-layout"
import { H1, H2, P1, ToolingText } from "../components/highlighted-work/text"
import hustlerEurope from '../images/hustler-turf-equipment/hustler-europe-site.mp4';
import customParallax from '../images/hustler-turf-equipment/custom-parallax-header.mp4';
import VideoPlayer from "../components/video-player";

export default function HustlerTurf() {
  return (
    <>
      <Seo title="Zac Remboldt | Hustler Turf Equipment" />
      <StandardLayout>
        <H1>Design & Development Hustler Turf Equipment</H1>

        <section>
          <H2>Reimagining hustlerturf.com</H2>
          <ToolingText>Primary tools: Figma, Principle, and lots of research</ToolingText>
          <P1>I was tasked with designing and prototyping a brand new hustlerturf.com with a primary focus on integrating eCommerce capabilities. The goal here was to create an intuitive flow from homepage to final checkout with opportunities to easily include accessories based on the model chosen.</P1>
          {/* TODO: make this a component where the height can be modified */}
          <div className="video-container" style={{ height: 'min(600px, 67vw)' }}>
            <VideoPlayer
              playbackId={'iUyqUzvCqkA003wWZlMJf17VNNgP7WKciHFP2BOp3m8I'}
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
        </section>
        <section>
          <H2>Hustler Turf Equipment | Europe Public Site</H2>
          <ToolingText>Primary tools: React, Google APIs, Sass, SalesForce</ToolingText>
          <P1>I designed and presented a working prototype based on needs defined by the export dept, then developed the final product. Most proud of the store locator which pulls data from SalesForce and displays nearest store info and location on a map.</P1>
          <div className="video-container" style={{ height: 'min(567px, 59vw)' }}>
            <video autoPlay loop muted playsInline>
              <source src={hustlerEurope} type="video/mp4" />
            </video>
          </div>
        </section>
        <section>
          <H2>Hustler Turf Equipment | Dealer Newsletter</H2>
          <ToolingText>Primary Tools: Vanilla Javascript, Pug, Sass, Parcel</ToolingText>
          <P1>As part of this project I created a fully custom parallax header from scratch using requestAnimationFrame. I learned a lot about performance optimization in JavaScript along the way.</P1>
          <div className="video-container" style={{ height: 'min(670px, 74vw)' }}>
            <video autoPlay loop muted playsInline>
              <source src={customParallax} type="video/mp4" />
            </video>
          </div>
        </section>
        {/* <section>
          <H2>Hustler Turf Equipment | Visual Identity</H2>
          <P1>Before moving into web/software I was one of three designers who shaped and brought definition to the Hustler Turf Equipment visual identity system.</P1>
          <StaticImage
            src="../images/hustler-turf-visual-identity.jpg"
            alt="Sketch-notes featuring my 100 days of code journey. (round 2)"
          />
        </section> */}

      </StandardLayout>
    </>
  )
}
